export default __webpack_public_path__ + "static/media/holdings-tile.bc2759d4.png";